import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'preview',
  production: true,
  hmr: false,
  api: {
    url: 'https://api-preprod.mylaveo.fr',
    version: 1,
    mock: false,
    graphQL: '/graphql'
  },
  oauth: {
    clientId: 'local-dev',
    clientSecret: 'secret'
  },
  googleMapsKey: 'AIzaSyCB6a5AtKQG77EGOlzBKDSWLRi8ILgkwyI',
  sentry: 'https://7a58267cab97bfe9f2aa483f1d294517@o4507684994940928.ingest.de.sentry.io/4507684996317264',
  flags: {
    enableReporting: true
  }
};
